import React from "react";
import Loader from "./Loader";
// import Spinner from "../../assets/img/illustrations/loader.gif";
// import sikkaLogo from "../../assets/img/icons/new-sikka-logo.png";

const FullPageLoader = () => {
  return (
    <div className="fp-container">
      <div className="fullbody-after-login">
        <Loader />
      </div>
    </div>
  );
};

export default FullPageLoader;
